@if (display) {
  <p-dialog  header="{{title}}" [(visible)]="display"
    [transitionOptions]="'150ms cubic-bezier(0, 0, 0.2, 1)'" [modal]="true" [draggable]="false" [resizable]="false"
    [closeOnEscape]="false"
    [style]="{width: '40vw'}">
    <div class="content">
      <div class="row mt-4 mb-4">
        <div class="col-sm-6">
          <label for="startDate" class="form-label custom-label fw-bold small mb-2 me-2" i18n><strong>
                {{'tableManagement.insurance.year' |
                translate}} (*)
            </strong></label>
          <div class="p-0"></div>
          <p-datepicker [disabled]="insurance" [(ngModel)]='year' [readonlyInput]='true' [showTime]='false'
            [style]="{'width':'200px'}" showIcon='true'
            appendTo='body' dateFormat="yy"
          view="year"></p-datepicker>
        </div>
        <div class="col-sm-6">
          <label for="endDate" class="form-label custom-label fw-bold small mb-2 me-2" i18n><strong>
                {{'tableManagement.insurance.quarter' |
                translate}} (*)
            </strong>
            </label>
        <div class="p-0"></div>
        <p-select [options]='quarterOptions' [(ngModel)]='selectedQuarter'
                    placeholder="{{'general.select' | translate}} {{'tableManagement.insurance.quarter' |
                    translate}}"
          [style]="{'width':'250px'}" appendTo='body'>
        </p-select>
      </div>
    </div>
    <div class="row mt-4 mb-4">
      <div class="col-sm-6">
        <label for="insurance-type" class="form-label custom-label fw-bold small mb-2 me-2" i18n><strong>{{'tableManagement.insurance.insuranceType' |
                translate}} (*)</strong></label>
        <div class="p-0"></div>
        <p-select [disabled]="insurance" [options]='insuranceTypeList' [(ngModel)]='selectedInsuranceType'
          placeholder="{{'general.select' | translate}} {{'tableManagement.insurance.insuranceType' | translate}}"
          dataKey='id' optionLabel='name' [style]="{'width':'250px'}" appendTo='body' [filter]="true"
          filterBy="name" (onChange)="onChangeInsuranceType($event)" (onFilter)="onFilterInsuranceType($event)">
        </p-select>
      </div>
      <div class="col-sm-6">
        <label for="insurance-provider" class="form-label custom-label fw-bold small mb-2 me-2" i18n><strong>{{'tableManagement.insurance.insurer' |
                translate}} (*)</strong></label>
        <div class="p-0"></div>
        <p-select [disabled]="insurance" [options]='providerList' [(ngModel)]='selectedProvider'
          placeholder="{{'general.select' | translate}} {{'tableManagement.insurance.insurer' | translate}}"
          dataKey='id' optionLabel='name' [style]="{'width':'250px'}" appendTo='body' [filter]="true"
          filterBy="name" (onChange)="onChangeProvider($event)" (onFilter)="onFilterProvider($event)">
        </p-select>
      </div>
    </div>
  </div>
<ng-template pTemplate="footer">
      <div class="d-flex align-items-center">
        <button class="btn custom-button float-end " (click)="calculate()"  [disabled]="disabled" i18n>
                {{'general.startProcess' | translate}}
            </button>
        <div class="p-3"></div>
        @if (disabled) {
          <mat-spinner [diameter]="30" strokeWidth="5" [color]="red"> </mat-spinner>
        }
      </div>
    </ng-template>
</p-dialog>
}
